module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "rank_index",
    staticClass: "rank_index"
  }, [_c('div', {
    staticClass: "rank_index_top"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "tab_box"
  }, _vm._l((this.categoryData), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        act: (_vm.isActive == item.category ? true : false)
      },
      on: {
        "click": function($event) {
          _vm.getRankList(item.category);
          _vm.isActive = item.category;
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.value) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "rank_index_icon left_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "rank_index_icon right_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "rank_index_fg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "rank_center_box"
  }, [(this.rankdata.length > 0) ? _c('div', {
    staticClass: "rank_list_box"
  }, _vm._l((this.rankdata), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "rank_list",
      class: _vm.getrank_top(index + 1)
    }, [_c('div', {
      staticClass: "rank_list_t"
    }, [_c('span', {
      staticClass: "rank_name",
      on: {
        "click": function($event) {
          return _vm.videoDetail(item.video_url)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "rank_num"
    }, [_vm._v("\n            总得分数："), _c('span', [_vm._v(_vm._s(item.total_score))]), _vm._v("分\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "rank_list_b"
    }, [_c('span', {
      staticClass: "rank_org"
    }, [_vm._v(_vm._s(item.org))]), _vm._v(" "), _c('span', {
      staticClass: "rank_vote"
    }, [_vm._v("投票数：" + _vm._s(item.total_vote) + "人")]), _vm._v(" "), _c('span', {
      staticClass: "rank_id"
    }, [_vm._v("视频ID：" + _vm._s(item.id))])]), _vm._v(" "), (index == 0) ? _c('div', {
      staticClass: "top_icon top_1"
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('div', {
      staticClass: "top_icon top_2"
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('div', {
      staticClass: "top_icon top_3"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rank_top_icon",
      class: _vm.gettop(index + 1)
    })])
  }), 0) : _c('div', {
    staticClass: "list_null"
  }, [_vm._v("暂无数据！！！")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频预览",
      "visible": _vm.videoPop,
      "width": "550px",
      "top": "200px",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoPop = $event
      },
      "close": _vm.closeVideoPop
    }
  }, [(_vm.videoUrl) ? _c('div', {
    staticClass: "video_box"
  }, [_c('video', {
    ref: "video",
    attrs: {
      "id": "video",
      "width": "500",
      "height": "350",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": this.videoUrl,
      "type": "video/mp4"
    }
  }), _vm._v("\n        您的浏览器不支持 video 标签。\n      ")])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rank_top"
  }, [_vm._v("投票活动截止到"), _c('span', [_vm._v("2024年8月31日")]), _vm._v("，最终获奖名单将于"), _c('span', [_vm._v("10月")]), _vm._v("公布，榜单每日更新一次。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-107a2fe6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/rank.vue
// module id = 499
// module chunks = 1